// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"82":"e8dec7efcdc6dc08","657":"1bd95b5a858d1212","1343":"72b2ee40f9982890","3527":"e2745835eec2cb6b"}[chunkId] + ".css";
};